import React from "react";
import { SidebarSecondary } from "../../elements/frontend/src/components";

const SideBar = () => {
  return <SidebarSecondary />;
};

export default SideBar;
